var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Task_task, _Task_metadata;
import { isNullOrEmpty } from "@ioip/core/lib/utilities";
export class Task {
    constructor(task) {
        var _a;
        _Task_task.set(this, void 0);
        _Task_metadata.set(this, void 0);
        __classPrivateFieldSet(this, _Task_task, task, "f");
        __classPrivateFieldSet(this, _Task_metadata, isNullOrEmpty((_a = __classPrivateFieldGet(this, _Task_task, "f")) === null || _a === void 0 ? void 0 : _a.Metadata) ? {} : JSON.parse(__classPrivateFieldGet(this, _Task_task, "f").Metadata), "f");
    }
    get Subject() {
        return __classPrivateFieldGet(this, _Task_task, "f").Subject || '';
    }
    get TaskTypeId() {
        return __classPrivateFieldGet(this, _Task_task, "f").TaskTypeId || 0;
    }
    get TaskId() {
        return __classPrivateFieldGet(this, _Task_task, "f").TaskId || 0;
    }
    get TaskStatusId() {
        return __classPrivateFieldGet(this, _Task_task, "f").TaskStatusId || 0;
    }
    get Description() {
        return __classPrivateFieldGet(this, _Task_task, "f").Description || '';
    }
    get InternalComunicationId() {
        return __classPrivateFieldGet(this, _Task_task, "f").InternalComunicationId || 0;
    }
    get InputFileId() {
        return __classPrivateFieldGet(this, _Task_task, "f").InputFileId || 0;
    }
    get OutputFileId() {
        return __classPrivateFieldGet(this, _Task_task, "f").OutputFileId || 0;
    }
    get Metadata() {
        return __classPrivateFieldGet(this, _Task_metadata, "f");
    }
}
_Task_task = new WeakMap(), _Task_metadata = new WeakMap();
export default Task;
